// import { useState, useEffect } from "react";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import "./statement.css";

const Statement = () => {
  return (
    <div>
      <NavBar linkColor="#000000" logo={ColoredLogo} bg="#fff" />
      {/* <div className="container"> */}
      <div className="statement-container">
        <h3 className="h3">GiftCard8 Accessibility Statement</h3>

        {/* <h6 className="h6">
            {" "}
            We are committed to providing easy access for everyone.
          </h6> */}
        <article>
          The GiftCard8 Gift Card Selling Platform dedicates itself to making
          our website easy to use for everyone. This includes people with
          visual, hearing, cognitive, and motor impairments. We are working hard
          to make our website easier to access. We want all users to have equal
          access to our platform. We want our website to be flexible. It should
          adapt to the needs and preferences of different users. It must also be
          accessible through various technologies, including mobile devices and
          assistive tools. Our goal is to comply with all applicable standards,
          including WCAG accessibility standards.
        </article>

        <br />

        <span>Continuous Improvement: </span>
        <article>
          We understand that accessible design is a continuous improvement
          process. We conduct accessibility assessments regularly and
          continuously optimize the accessibility features of the platform based
          on user feedback. If you encounter any accessibility issues when using
          the GiftCard8 platform, please feel free to contact us. We will
          resolve and improve your experience as soon as possible.
        </article>

        <br />
        <article>
          Thank you for choosing GiftCard8 Gift Card Selling Platform. We
          dedicate ourselves to providing you with a simple and easy experience.
          We want your gift card transactions to be easier and more enjoyable!
        </article>

        <br />
        <span>Final statement:</span>
        <br />
        <article>
          We will update this accessibility statement as needed. This ensures we
          meet the latest accessibility standards and user needs. We thank you
          for your support and understanding.
        </article>

        <br />
        <article>
          With this accessibility statement, we want to show that GiftCard8
          values all users. We aim to make sure everyone can use our platform
          easily. If you have any specific accessibility needs or questions,
          please feel free to contact us.
        </article>

        <br />
        <p className="p">Updated: November 2024</p>
      </div>
      {/* </div> */}
    </div>
  );
};

export default Statement;
